import { Effect } from "../../Materials/effect";
import "./sceneVertexDeclaration";
import "./meshVertexDeclaration";
var name = 'shadowMapVertexDeclaration';
var shader = "#include<sceneVertexDeclaration>\n#include<meshVertexDeclaration>\n";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */

export var shadowMapVertexDeclaration = {
  name: name,
  shader: shader
};